import React from "react";
import UserCreateContainer from "../../../../Component/Application/Users/CreateUser/UserCreate";

const AddUser = () => {
  return (
    <div className="page-body">
      <UserCreateContainer />
    </div>
  );
};

export default AddUser;
